import { generateConfidenceColors } from "./generateConfidenceColors";
const primary = "59.9% 0.107 2.655"; // love - muted pink
const content = "46.0% 0.063 289.556"; // text - dark purple-gray

export const rosePineDawnTheme = {
  name: "rose-pine-dawn",
  default: false,
  prefersDark: false,
  colorScheme: "light",
  colors: {
    // Base colors - layered light backgrounds (warm tinted)
    "base-100": "97.0% 0.011 71.900", // base - primary background #faf4ed
    "base-200": "98.7% 0.011 76.600", // surface - secondary background #fffaf3
    "base-300": "93.8% 0.018 73.072", // overlay - tertiary background #f2e9de
    "base-content": "46.0% 0.063 289.556", // text - dark purple-gray #575279

    // Primary colors - signature rose-pine muted pink
    "primary": "59.9% 0.107 2.655", // love - muted pink #b4637a
    "primary-content": "97.0% 0.011 71.900", // base for contrast

    // Secondary colors - pine teal
    "secondary": "49.1% 0.077 227.998", // pine - teal/cyan #286983
    "secondary-content": "97.0% 0.011 71.900", // base for contrast

    // Accent colors - iris purple
    "accent": "61.7% 0.074 305.698", // iris - soft purple #907aa9
    "accent-content": "97.0% 0.011 71.900", // base for contrast

    // Neutral colors
    "neutral": "93.8% 0.018 73.072", // overlay
    "neutral-content": "46.0% 0.063 289.556", // text

    // Semantic colors
    "info": "62.9% 0.066 210.123", // foam - light blue #56949f
    "info-content": "97.0% 0.011 71.900", // base for contrast

    "success": "49.1% 0.077 227.998", // pine - teal/cyan #286983
    "success-content": "97.0% 0.011 71.900", // base for contrast

    "warning": "75.5% 0.146 69.743", // gold - warm orange #ea9d34
    "warning-content": "46.0% 0.063 289.556", // text for contrast

    "error": "59.9% 0.107 2.655", // love - muted pink #b4637a
    "error-content": "97.0% 0.011 71.900", // base for contrast

    // Confidence levels for Tamil learning
    ...generateConfidenceColors(primary, content, false)
  },
  dimensions: {
    "radius-selector": "0.5rem",
    "radius-field": "0.5rem",
    "radius-box": "0.5rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "0",
    "noise": "0"
  }
};
